import create from "zustand";
import { devtools } from "zustand/middleware"

import { getBranch } from '../api/user.api'

const User = (set, get) => ({
	Branches: null,
	
	getBranches: async (BType, enqType, value) => {
		await getBranch().then((r) => {
			if(r.data.response_code === '01'){
				set({ Branches: r.data.branch_ids })
			}else{
				set({ Branches: null })
			}
		})
	}
});

const UserStore = create(
	devtools(User)
);

export default UserStore